import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { savePhaseItem } from 'actionCreators/phase_items';
import ColoredButton from 'components/ColoredButton';
import ConfirmDialog from 'components/ConfirmDialog';
import S from './releaseMerchandise.scss';

const WAREHOUSE_MERCH_ITEM_TYPE = 'warehouseMerchandiseItems';
const WAREHOUSE_PADS_ITEM_TYPE = 'phaseLineItems';
const RELEASED = 'Released';

class ReleaseMerchandise extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalActive: false,
    };

    this.handleRelease = this.handleRelease.bind(this);
  }

  hasUnreleasedItems = appt =>
  (appt.warehouse_merchandise_items.filter(i => i.status !== RELEASED).length > 0 ||
    appt.phase_line_items.filter(i => i.warehouse_status !== RELEASED).length > 0);

  handleRelease = (appt) => {
    const { warehouse_merchandise_items, phase_line_items, phase: { id } } = appt;
    this.releaseWarehouseMerch(warehouse_merchandise_items, id);
    this.releaseWarehousePads(phase_line_items, id);
    this.toggleModalActive();
  }

  releaseWarehouseMerch = (merch, phaseId) => {
    if (merch.length > 0) {
      merch.forEach((item) => {
        const lineItem = item;
        lineItem.status = RELEASED;
        this.props.savePhaseItem(phaseId, lineItem, WAREHOUSE_MERCH_ITEM_TYPE);
      });
    }
  }

  releaseWarehousePads = (pads, phaseId) => {
    if (pads.length > 0) {
      pads.forEach((pad) => {
        const lineItem = pad;
        lineItem.warehouse_status = RELEASED;
        this.props.savePhaseItem(phaseId, lineItem, WAREHOUSE_PADS_ITEM_TYPE);
      });
    }
  }

  toggleModalActive = () => this.setState({ modalActive: !this.state.modalActive });

  render() {
    const { appt } = this.props;
    const { modalActive } = this.state;
    const hasUnreleasedItems = this.hasUnreleasedItems(appt);
    return (
      <div>
        <ColoredButton
          color="green"
          label={hasUnreleasedItems ? 'Release All' : 'Released'}
          disabled={!hasUnreleasedItems}
          className={S.receive}
          onClick={() => this.toggleModalActive(appt)}
        />
        {modalActive &&
          <ConfirmDialog
            title="Mark all Warehouse Merchandise and Pads as Released?"
            okLabel="Yes"
            cancelLabel="Cancel"
            cancel={this.toggleModalActive}
            dismiss={this.toggleModalActive}
            proceed={() => this.handleRelease(appt)}
          />
        }
      </div>
    );
  }
}

ReleaseMerchandise.propTypes = {
  appt: PropTypes.object,
  savePhaseItem: PropTypes.func.isRequired,
};

export default connect(null, { savePhaseItem })(ReleaseMerchandise);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/components/ReleaseMerchandise/index.jsx